(function () {

    'use strict';

    angular.module('Services').factory('AreasTableService', AreasTableService);
    AreasTableService.$inject = [
        'FleetService',
        'TableLiteFactory',
        'toastr',
        '$location'
    ];
    function AreasTableService(
        FleetService,
        TableLiteFactory,
        toastr,
        $location
    ) {
        return function (defaultFilters) {
            let tableData = {
                tableName: 'AreasTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'ADD NEW',
                        tooltip: 'Click to create a new Area',
                        onClick: function () {
                            $location.path('/areas/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [{
                    label: 'Area ID',
                    viewName: 'areaId',
                    filterName: 'areaId',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Office Name',
                    viewName: 'officeName',
                    filterName: 'officeName',
                    filter: {
                        type: 'text',
                        onSubmit: function(header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    }
                }, {
                    label: 'Carrier Profile',
                    viewName: 'carrierProfile',
                    filter: {
                        type: 'text',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    }
                }, {
                    label: 'Sort Code',
                    viewName: 'sortCode',
                    filter: {
                        type: 'text',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    }
                }, {
                    label: 'Total Number of Jobs',
                    viewName: 'totalJobs',
                    filterName: 'totalJobs',
                    /*filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },*/
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Number of Jobs for the Day',
                    viewName: 'todayTotalJobs',
                    filterName: 'todayTotalJobs',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Zones/Postcodes',
                    viewName: 'multiZones',
                    filterName: 'zones'/*,
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }*/
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model === 'Active';
                            tableActions.sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: ()=>{
                    tableActions.resetFilters();
                },
                onInit: function () {
                    tableActions.sendRequest({});
                }
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: FleetService.Areas.getAll,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'id,asc'
                    }, defaultFilters)
                }
            );

            function buildTableData(data) {
                /*** START - Building of Data ***/
                if (!data) return tableData;

                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.status = {
                        type: 'status',
                        status: item.active,
                        label: item.active ? 'Active' : 'Inactive'
                    };
                    item.href = `/areas/details/${item.id}`;
                    item.todayTotalJobs = item.todayTotalJobs || 0;
                    item.totalJobs = item.totalJobs || 0;
                    item.sortCode = item.sortCode || 'N/A';
                    item.carrierProfile = angular.getObjVal(item, 'carrierProfile.name') || 'N/A'
                    item.officeName = angular.getObjVal(item, 'officeName') || 'N/A';
                    item.multiZones = {
                        type: 'multiLine',
                        list: item.zones.map(z=>{
                            const {zone} = z;
                            if(zone) return `${zone.name} (${zone.code})`;
                            return 'N/A';
                        })
                    };
                    tableData.data.push(item);
                });
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/AreasTableService.js